import styled from "styled-components";

export const BannerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 165px;
  background: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media (min-width: 744px) {
    width: 100%;
    height: 165px;
  }

  @media (min-width: 744px) {
    width: 100%;
    height: 180px;
  }

  @media (min-width: 1440px) {
    width: 100%;
    height: 350px;
  }

  span {
    background-color: rgba(0, 59, 111, 0.4);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const BannerTitle = styled.div`
  font-weight: 600;
  font-size: 48px;
  color: #ffbf3a;
  z-index: 1;
`;

export const BannerSubTitle = styled.div`
  font-weight: 300;
  font-size: 24px;
  color: #ffffff;
  z-index: 1;
`;
